import { ComponentType } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { ProductFinderContentPageQuery_productFinderContentPage_sections } from '@app/hooks/useContentPage/__generated__/ProductFinderContentPageQuery';
import {
  getLocaleFromPathname,
  getIntlValidLocale,
} from '../../../helpers/locale';
import FeaturedProducts, { FeaturedProductsProps } from './FeaturedProducts';
import GetProductBySkuQuery from './getProductsBySku.query';
import {
  getProductsBySku,
  getProductsBySku_getProducts_result_items as Product,
} from './__generated__/getProductsBySku';

interface QueryResult extends getProductsBySku {
  loading: boolean;
}

interface QueryVariables {
  language: String;
  condition: { in: { key: string; value: string[] } };
}

interface Loading {
  loading: boolean;
}

interface QueryOutput extends Loading {
  products: Product[] | undefined;
}

const withProducts = graphql<
  FeaturedProductsProps,
  QueryResult,
  QueryVariables,
  Loading | QueryOutput
>(GetProductBySkuQuery, {
  options: ({ location, skus }) => {
    const language =
      location && location.pathname
        ? getIntlValidLocale(getLocaleFromPathname(location.pathname))
        : 'en';

    const condition = { in: { key: 'objectID', value: skus } };
    return { variables: { language, condition } };
  },
  skip: ({ skus }) => skus.length === 0,
  props: ({ data, ownProps: { skus } }) => {
    const { loading, getProducts } = data as QueryResult;
    if (loading) return { loading };

    const products = getProducts?.result?.items ?? [];
    const sortedProducts = products
      .slice()
      .sort((a, b) => skus.indexOf(a.sku ?? '') - skus.indexOf(b.sku ?? ''));

    return {
      loading,
      products: sortedProducts,
    };
  },
});

export default compose(
  withRouter,
  withProducts
)(
  FeaturedProducts
) as ComponentType<ProductFinderContentPageQuery_productFinderContentPage_sections>;
